import * as React from 'react'

import styled from 'styled-components'
import * as S from '../../../styles'
import * as glyphs from '../../../icons/glyphs'

import { Field } from './Field'
import { FieldStatus } from './FieldStatus'

export type DatePickerFieldProps = React.InputHTMLAttributes<HTMLInputElement> & {
  label?: React.ReactNode
  error?: React.ReactNode
  success?: React.ReactNode
  showTimeSelectOnly?: boolean
}

function DatePickerFieldComponent({
  className,
  error,
  success,
  showTimeSelectOnly,
  ...inputProps
}: DatePickerFieldProps): React.ReactElement<DatePickerFieldProps> {
  let status: 'default' | 'error' | 'success' = 'default'
  if (error && !success) {
    status = 'error'
  }
  if (success && !error) {
    status = 'success'
  }

  if (!showTimeSelectOnly) {
    return (
      <Field className={className} htmlFor={inputProps.id} onClick={inputProps.onClick}>
        <S.datePicker.InputWrapper $status={status} $disabled={inputProps.disabled}>
          <S.input.Prefix>
            <glyphs.stroke.Calendar size={18} />
          </S.input.Prefix>
          <S.datePicker.CustomInput {...inputProps} />
        </S.datePicker.InputWrapper>

        {(error || success) && <FieldStatus error={error} success={success} />}
      </Field>
    )
  } else {
    return (
      <Field className={className} htmlFor={inputProps.id} onClick={inputProps.onClick}>
        <S.datePicker.DropdownWrapper $status={status} $disabled={inputProps.disabled}>
          <S.select.Label>{inputProps.value === '' ? inputProps.placeholder : inputProps.value}</S.select.Label>
          <glyphs.fill.CaretDown size={11} />
        </S.datePicker.DropdownWrapper>
        {(error || success) && <FieldStatus error={error} success={success} />}
      </Field>
    )
  }
}

export const DatePickerField = styled(DatePickerFieldComponent)<DatePickerFieldProps>``
DatePickerField.displayName = 'DatePickerField'
